import { Component, OnInit } from '@angular/core';
import { DadoTransacional } from '../../comum/modelos/dado-transacional';
import { ConstrucaoVariaveisService } from '../construcao-variaveis.service';
import { ComumService } from '../../comum/comum.service';
import { Router } from '@angular/router';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-construcao-variavel',
  templateUrl: './construcao-variavel.component.html',
  styleUrls: ['./construcao-variavel.component.css']
})
export class ConstrucaoVariavelComponent implements OnInit {

  public dadosTransacionais1: DadoTransacional[];
  public dadosTransacionais2: DadoTransacional[];
  public dadoTransacional1: DadoTransacional;
  public dadoTransacional2: DadoTransacional;
  public variavel1: number;
  public variavel2: number;
  public radioDadoTransacional1: boolean;
  public radioDadoTransacional2: boolean;
  public operacao: string;

  public loading = false;
  public statusCode: number;

  constructor(private _construcaoVariaveisService: ConstrucaoVariaveisService,
    private _comumService: ComumService,
    private router: Router,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.dadosTransacionais1 = new Array<DadoTransacional>();
    this.dadosTransacionais2 = new Array<DadoTransacional>();
    this.dadoTransacional1 = new DadoTransacional();
    this.dadoTransacional2 = new DadoTransacional();

  }

  ngOnInit() {
    this.loading = true;
    this._construcaoVariaveisService.obterDadosTransacionaisClienteHttp(parseInt(this._cookieService.get('idCliente')))
      .subscribe((dadosTransacionais) => {
        this.dadosTransacionais1 = dadosTransacionais;
        this.dadosTransacionais2 = dadosTransacionais;
        this.loading = false;
      });
  }

  onSubmit(): void {
    const self = this;

    this._construcaoVariaveisService.atualizarDadoTransacionalHttp(this.dadoTransacional1)
      .subscribe(response => {
        this.loading = false;
        this.statusCode = response.status;
        this._comumService.evento.cadastro = true;
        self.router.navigate(['variaveis']);
      }, errorCode => {
        this.statusCode = errorCode;
        this.loading = false;
      });
  }

  selecionarDadoTransacional(idDadoTransacional: number): void {
    this._construcaoVariaveisService.obterDadoTransacionalPorIdHttp(idDadoTransacional)
      .subscribe((dadoTransacional: DadoTransacional) => {
        this.dadoTransacional1 = dadoTransacional;
      });
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/construcao-variaveis/construcao-variavel/construcao-variavel.component.ts